import { Component, OnInit, Input, Output, EventEmitter, ViewChildren, SimpleChanges, TemplateRef} from '@angular/core';

import * as _ from 'lodash';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { environment } from 'src/environments/environment';
import { UtilService } from 'src/app/modules/shared/services/util.service';
import { CouponsService } from 'src/app/modules/retailer/services/coupons.service';

@Component({
  selector: 'app-manage-brand',
  templateUrl: './manage-brand.component.html',
  styleUrls: ['./manage-brand.component.scss']
})
export class ManageBrandComponent implements OnInit {

  @Input() module: string; // (CPG/RETAILER/ADMIN)
  @Output() actions = new EventEmitter(); // Actions from component

  public loginData: any;

  public manufacturers: any = [];
  public manufacturersLoading: boolean = false;
  public selectedManufacturer: any = 0;

  public brands: any = [];
  public currentAction: string;

  public brandName!: string;

  constructor(
    private _utilService: UtilService,
    private _couponsService: CouponsService
  ) { }

  ngOnInit(): void {
    this.getStorageData();
  }

  async getStorageData() {
    if(this.module == 'RETAILER') {
      this.loginData = await this._utilService.getStorageData('R_LOGIN');
    } else if(this.module == 'ADMIN') {
      this.loginData = await this._utilService.getStorageData('A_LOGIN');
    }

    this.getManufacturers();
  }

  // Get manufacturers
  getManufacturers() {
    this.manufacturers = [];
    this.manufacturersLoading = true;

    this._couponsService.getManufacturers(this.loginData.token, this.loginData.user_details.provider_type, this.loginData.user_details.provider_id, false).subscribe(async getManufacturersResponse => {
      this.manufacturersLoading = false;

      if (getManufacturersResponse.status === true) { // Success
        this.manufacturers = getManufacturersResponse.manufacturers;

        if (this.manufacturers.length > 0) {
          this.selectedManufacturer = this.manufacturers[0].mfg_id
          this.getBrands();
        }
      } else {
        this._utilService.showToast(getManufacturersResponse.message, '', 'error', {});
      }
    }, error2 => { // Error from getCouponTypes
      this.manufacturersLoading = false;
    });
  }

  // Get brands
  getBrands() {
    this.brands = [];
    this.currentAction = 'getBrands';

    this._couponsService.getBrands(this.loginData.token, this.loginData.user_details.provider_type, this.loginData.user_details.provider_id, this.selectedManufacturer).subscribe(async getBrandsResponse => {
      this.currentAction = '';
      if (getBrandsResponse.status === true) { // Success
        this.brands = getBrandsResponse.brands;
      } else {
        this._utilService.showToast(getBrandsResponse.message, '', 'error', {});
      }
    }, error2 => { // Error from getBrands
      this.currentAction = '';
    });
  }

  // Manufacturer change
  onManufacturerChange(event: any) {
    this.getBrands();
  }

  // Add/edit/delete brand
  manageBrand() {
    if (!this.brandName) {
      this._utilService.showToast('Please enter new brand name', '', 'warning', {});
    } else {
      this.currentAction = 'manageBrand';

      let manageBrandBody: any = {
        mode: 'add', 
        mfg_id: this.selectedManufacturer,
        name: this.brandName
      }

      this._couponsService.manageBrand(this.loginData.token, manageBrandBody).subscribe(async manageBrandResponse => {
        this.currentAction = '';

        if (manageBrandResponse.status === true) { // Success
          this._utilService.showToast('New brand "' + this.brandName + '" is added.', '', 'success', {});
          this.actions.emit({ action: 'added' });
        } else {
          this._utilService.showToast(manageBrandResponse.message, '', 'error', {});
        }
      }, error2 => { // Error from manageBrand
        this.currentAction = '';
      });
    }
  }

}
